import { Component, OnInit, Input, EventEmitter, Output, HostListener, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { PartDetailService } from './part-detail.service';

@Component({
    selector: 'part-detail',
    templateUrl: './part-detail.component.html',
    styleUrls: ['./part-detail.component.scss']
})
export class PartDetailComponent implements OnInit {
    show = false;
    part: any;
    editForm: FormGroup;
    contentWidth: number;  // the calculated width of the content
    contentWidthPercent = .85; // the percent the width of the content takes up on the screen
    contentHeight: number; // the calculated height of the content
    contentHeightPercent = 0.8; // the percent the height of the content takes up on the screen
    isEditing: boolean;
    subscription: Subscription;
    isVisDialog: boolean;
    isOpen: boolean;
    isShowPartSummary = true;
    isShowPartDetail = true;

    @Input()
    set data(obj: any) {
        this.show = (obj !== undefined && obj != null);
        if (obj) {
            this.part = obj;
            if (!this.part.Id) { this.editDetails(); }
        }
    }
    @Output()
    close: EventEmitter<any> = new EventEmitter();
    @Output()
    save: EventEmitter<any> = new EventEmitter();

    @ViewChild('partDetailHeader', { static: false }) partDetailHeader;
    @ViewChild('general', { static: false }) general;
    @ViewChild('die', { static: false }) die;
    @ViewChild('partHandling', { static: false }) partHandling;
    @ViewChild('partLoading', { static: false }) partLoading;
    @ViewChild('container', { static: false }) container;
    @ViewChild('press', { static: false }) press;

    constructor(public messageService: PartDetailService) {
        this.isOpen = true;
        this.subscription = this.messageService.getMessage()
            .subscribe(message => {
                this.isEditing = message.editing;
            });

        // Toggle to hide/show detail dialog
        this.messageService.isShowPartDetail
            .subscribe(x => this.isVisDialog = x);
    }

    // Ng methods
    ngOnInit() {
        this.updateWindowSize();
    }

    @HostListener('window:resize')
    onResizeWindow() {
        this.updateWindowSize();
    }

    private updateWindowSize() {
        this.contentWidth = window.innerWidth;
        if (this.contentWidth > 1600) {
            this.contentWidth = window.innerWidth * this.contentWidthPercent;
        }

        this.contentHeight = window.innerHeight;
        if (this.contentHeight > 768) {
            this.contentHeight = window.innerHeight * this.contentHeightPercent;
        }
    }

    // isEditing Status Methods
    editDetails(): void {
        this.messageService.edit();
    }

    saveDetail(): void {
        this.messageService.save(false);
        this.save.emit();
    }

    refreshToolSetDetail(): void{
        this.save.emit();
    }

    closeForm() {
        this.messageService.close();
        this.close.emit();
    }

    isDisabled(): boolean {
        if (this.partDetailHeader) {
            return (!this.partDetailHeader.editForm.valid);
        }
        return true;
    }

    isLoading(): boolean {
        if (this.partDetailHeader && this.general && this.die && this.partHandling && this.partLoading && this.container && this.press && this.messageService) {
            return (this.partDetailHeader.isLoading ||
                this.general.isLoading ||
                this.die.isLoading ||
                this.partHandling.isLoading ||
                this.partLoading.isLoading ||
                this.container.isLoading ||
                this.press.isLoading ||
                this.messageService.isLoading);
        }
        return true;
    }

    readonly handleZoomInDialogClose = () => {
        this.messageService.showZoomInDialog = false;
    }

    readonly togglePartSummary = () => {
        this.isShowPartSummary = !this.isShowPartSummary;
    }

    readonly togglePartDetail = () => {
        this.isShowPartDetail = !this.isShowPartDetail;
    }
}
